import { render, staticRenderFns } from "./productionManage.vue?vue&type=template&id=321a24b8&scoped=true"
import script from "./productionManage.vue?vue&type=script&lang=js"
export * from "./productionManage.vue?vue&type=script&lang=js"
import style0 from "./productionManage.vue?vue&type=style&index=0&id=321a24b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a24b8",
  null
  
)

export default component.exports